import { render, staticRenderFns } from "./TopConcertInfo.vue?vue&type=template&id=f7ffd2fe&scoped=true&"
import script from "./TopConcertInfo.vue?vue&type=script&lang=js&"
export * from "./TopConcertInfo.vue?vue&type=script&lang=js&"
import style0 from "./TopConcertInfo.vue?vue&type=style&index=0&id=f7ffd2fe&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7ffd2fe",
  null
  
)

export default component.exports